module.exports = __webpack_public_path__ + "img/nishimura.80716a46.png";